import { render, staticRenderFns } from "./navtop.vue?vue&type=template&id=5ab7ac40&scoped=true"
import script from "./navtop.vue?vue&type=script&lang=js"
export * from "./navtop.vue?vue&type=script&lang=js"
import style0 from "./navtop.vue?vue&type=style&index=0&id=5ab7ac40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7ac40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab7ac40')) {
      api.createRecord('5ab7ac40', component.options)
    } else {
      api.reload('5ab7ac40', component.options)
    }
    module.hot.accept("./navtop.vue?vue&type=template&id=5ab7ac40&scoped=true", function () {
      api.rerender('5ab7ac40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/navtop.vue"
export default component.exports